import { TFunction } from 'i18next';

/** A refused Data Gateway write; `message` is a translation key. */
export class MutationSaveError extends Error {}

export interface MutationResult {
  itemId?: string | null;
  totalImpactedData?: number | null;
  acknowledged?: boolean | null;
}

// A data-rule refusal still answers HTTP 200, so a write counts only when it says it changed something.
export const assertMutationSaved = (
  result: MutationResult | undefined,
  isInsert: boolean,
  failureKey: string
) => {
  const saved =
    result?.acknowledged !== false &&
    (isInsert ? Boolean(result?.itemId) : (result?.totalImpactedData ?? 0) > 0);
  if (!saved) throw new MutationSaveError(failureKey);
};

/** Turns a `MutationSaveError` key into its translated text for the global error toast. */
export const translateSaveError = <T>(t: TFunction, save: Promise<T>): Promise<T> =>
  save.catch((error: unknown) => {
    throw error instanceof MutationSaveError ? new Error(t(error.message)) : error;
  });
